export default __webpack_public_path__ + "static/media/Schulung Meldepflicht.08ec8df0.jpg";